<template>
<div id="filter-content" class="sticky-top">
    <div v-if="filter == 'filter'" class=" filter">
        <div class="row justify-content-center">
            <div class="col-sm-5">
                <input v-on:keyup="updateFilter" v-model="searchText" type="text" class="form-control" aria-describedby="search" placeholder="What kind of game are you looking for?">
            </div>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
export default {
  name: "filter-template",
  data () {
    return {
      type: 'all',
      status: 'all',
      blockchain: 'all',
      filter: 'filter',
      searchText: ''
    }
  },
  methods: {
    updateFilter (type) {
      const filters = {
        type: this.type,
        search: this.searchText
      }

      this.$store.commit('setFilters', { filters });
      this.$store.commit('setFilteredConfessions', { type: 'filter' });
    }
  }
};
</script>

<style scoped lang="less">
#filter-content {
  padding: 25px;
  background: #f7f7f7;
  border-bottom: 1px solid #ccc;
}

@media only screen and (max-width: 600px) {
    select, input {
      margin-bottom: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/TheFilter.vue